import { faUser } from "@fortawesome/free-solid-svg-icons";
import { isDefinedString, isPositiveNumber } from "et3-type-guards";
import React from "react";
import { useNavigate } from "react-router-dom";
import { USER_MESSAGES_TYPE } from "../../../../constants/picker-entries-constants";
import i18n from "../../../../constants/i18n";
import getUserStore from "../../../../stores/user-store";
import getUserMessagesStore from "../../../../stores/user-store/messages-store";
import Et3Button from "../../../../core/et3-button";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3TextInput from "../../../../core/et3-input/et3-text-input";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import Et3Picker from "../../../../core/et3-input/et3-picker";
import { TEt3PickerSingleValue } from "../../../../TypesNEW";

const UserMessagesForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const navigate = useNavigate();
  const userID = getUserStore().userIdInput.get();

  return (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3TextInput
          size="MEDIUM"
          withShadow={true}
          type={"number"}
          icon={faUser}
          label={i18n.get("USER_ID")}
          placeHolder={i18n.get("USER_ID")}
          onChoose={(value: number) => {
            getUserStore().userIdInput.set(value);
          }}
          onBlur={() => {}}
          value={getUserStore().userIdInput.get()}
          onEnter={async () => {
            await getUserMessagesStore().getUserMessages({
              isLoadMore: false
            });
            navigate({
              pathname: window.location.pathname,
              search: `?id=${getUserStore().userIdInput.get()}`
            });
          }}
          style={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Picker
          label={i18n.get("MESSAGE_TYPE")}
          options={USER_MESSAGES_TYPE}
          onChoose={(value: TEt3PickerSingleValue) => {
            const isDefinedValue = isDefinedString(value.value);
            if (isDefinedValue) {
              getUserMessagesStore().setUserMessagesType(value);
            }
          }}
          value={getUserMessagesStore().userMessagesType.get()}
          isMultiple={false}
          style={{}}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />

        <Et3Picker
          label={i18n.get("MESSAGE_ERA")}
          options={[
            { label: "POST_2025", value: "POST_2025" },
            { label: "PRE_2025", value: "PRE_2025" }
          ]}
          value={getUserMessagesStore().messageEra.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getUserMessagesStore().setMessageEra(value);
          }}
          isMultiple={false}
          style={{}}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        isEnabled={isPositiveNumber(userID)}
        onClick={async () => {
          await getUserMessagesStore().getUserMessages({
            isLoadMore: false
          });
          navigate({
            pathname: window.location.pathname,
            search: `?id=${getUserStore().userIdInput.get()}`
          });
        }}
        size="LARGE"
        type="GET"
        text="GET"
      />
    </React.Fragment>
  );
});

export default UserMessagesForm;
